/**
 * One stroked icon set at 24 units, sized entirely from CSS. Line icons rather than filled glyphs
 * because everything else on screen is a thin rule or a bar, and a filled blob would not belong.
 */

export type IconName =
	| "scan"
	| "tag"
	| "card"
	| "cards"
	| "clock"
	| "gift"
	| "plus"
	| "minus"
	| "trash"
	| "torch"
	| "refresh"
	| "check"
	| "alert"
	| "info"
	| "pin"
	| "chevron"
	| "close"
	| "keyboard"
	| "merge";

const PATHS: Record<IconName, string> = {
	scan: "M4 8V6a2 2 0 0 1 2-2h2 M16 4h2a2 2 0 0 1 2 2v2 M20 16v2a2 2 0 0 1-2 2h-2 M8 20H6a2 2 0 0 1-2-2v-2 M3 12h18",
	tag: "M3 12.4V5a2 2 0 0 1 2-2h7.4a2 2 0 0 1 1.4.6l6.6 6.6a2 2 0 0 1 0 2.8l-6.6 6.6a2 2 0 0 1-2.8 0L3.6 13.8a2 2 0 0 1-.6-1.4Z M7.5 7.5h.01",
	card: "M2 7.5A2.5 2.5 0 0 1 4.5 5h15A2.5 2.5 0 0 1 22 7.5v9a2.5 2.5 0 0 1-2.5 2.5h-15A2.5 2.5 0 0 1 2 16.5v-9Z M2 10h20 M6 14.5h4",
	cards: "M6 8.5A2.5 2.5 0 0 1 8.5 6h11A2.5 2.5 0 0 1 22 8.5v7a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 6 15.5v-7Z M6 11h16 M2 9v8.5A2.5 2.5 0 0 0 4.5 20H17",
	clock: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z M12 7.5V12l3.5 2",
	gift: "M4 10h16v11H4V10Z M3 6.5h18V10H3V6.5Z M12 6.5V21 M12 6.5C9.5 6.5 7 5.5 7 3.8 7 2.7 7.8 2 8.9 2 10.5 2 12 4.1 12 6.5Z M12 6.5c2.5 0 5-1 5-2.7C17 2.7 16.2 2 15.1 2 13.5 2 12 4.1 12 6.5Z",
	plus: "M12 5v14 M5 12h14",
	minus: "M5 12h14",
	trash: "M4 7h16 M9 7V5.5A1.5 1.5 0 0 1 10.5 4h3A1.5 1.5 0 0 1 15 5.5V7 M6.5 7l.8 12.1A2 2 0 0 0 9.3 21h5.4a2 2 0 0 0 2-1.9L17.5 7",
	torch: "M13 2 4.5 13.5H11l-1 8.5 8.5-11.5H12l1-8.5Z",
	refresh: "M20 11a8 8 0 1 0-2.3 6.2 M20 4.5V11h-6.5",
	check: "M4.5 12.5 9.5 17.5 19.5 6.5",
	alert: "M12 9v4.5 M12 17h.01 M10.3 3.9 2.6 17.2a2 2 0 0 0 1.7 3h15.4a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z",
	info: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z M12 11.5v5 M12 8h.01",
	pin: "M12 15v6 M8 4h8l-1 7.5 2 2V15H7v-1.5l2-2L8 4Z",
	chevron: "M9 5l7 7-7 7",
	close: "M6 6l12 12 M18 6 6 18",
	keyboard: "M3 7.5A1.5 1.5 0 0 1 4.5 6h15A1.5 1.5 0 0 1 21 7.5v9a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 16.5v-9Z M7 10h.01 M11 10h.01 M15 10h.01 M8 14h8",
	merge: "M6 3v5.5a4 4 0 0 0 4 4h8 M18 3v5.5a4 4 0 0 1-4 4H10 M15 16.5l3-3.5-3-3.5",
};

export function Icon({ name }: { name: IconName }) {
	return (
		<svg
			className="icon"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.75"
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden="true"
			focusable="false"
		>
			<path d={PATHS[name]} />
		</svg>
	);
}
